import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
  import Pagination from '@/components/common/Pagination.vue'
  import PlaceholderShimmer from '@/components/common/PlaceholderShimmer.vue'
  import AuthorAudioSection from '@/components/course/AuthorAudioSection.vue'
  import TextRenderer from '@/components/editor/TextRenderer.vue'
  import type { PropType } from 'vue'
  import type { Slideshow } from '@/services/interfaces/Course'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LessonSlideshowModal',
  props: {
    slides: {
      type: Array as PropType<Slideshow[]>,
      required: true,
    },
    pageNumber: {
      type: Number,
      required: true,
    },
  },
  setup(__props) {

const props = __props;

  

  const currentPage = ref(props.pageNumber)
  const currentSlide = computed(() => props.slides[currentPage.value - 1])

return { __sfc: true,props, currentPage, currentSlide, computed, ref, Pagination, PlaceholderShimmer, AuthorAudioSection, TextRenderer }
}

})